function dontixNormalizeSearch(value) {
  const term = value.trim().normalize('NFC');
  if (/^[a-z0-9]+(?:-[a-z0-9]+)+$/i.test(term) && /\d/.test(term)) return term;
  let query = term
    .replace(/\bMcLaughlin[ -]+Bennett[ -]+Trevisi\b/gi, 'MBT')
    .replace(/\bNi[- ]?Ti\b/gi, 'Nickel Titan')
    .replace(/\bnickel[ -]+titanium\b/gi, 'Nickel Titan')
    .replace(/\b(?:beta[ -]titan(?:ium)?|titanium[ -]molybdenum(?:[ -]alloy)?)\b/gi, 'TMA')
    .replace(/\bstainless[ -]+steel\b/gi, 'Edelstahl')
    .replace(/\b(?:arch[ -]?wires?|boegen)\b/gi, 'Bögen')
    .replace(/\b(?:upper[ -]+(?:arch|jaw)|maxillary)\b/gi, 'Oberkiefer')
    .replace(/\b(?:lower[ -]+(?:arch|jaw)|mandibular)\b/gi, 'Unterkiefer')
    .replace(/\b(?:self[ -]?ligating|self[ -]?ligation|SLB)\b/gi, 'Selbstligierend')
    .replace(/\bSL(?=\s+brackets?\b)/gi, 'Selbstligierend')
    .replace(/\b(?:power[ -]?chains?|elastomeric[ -]+chains?|elastikketten)\b/gi, 'Elastische Ketten')
    .replace(/\b(?:elastic[ -]+ligatures?|elastomeric[ -]+ligatures?|ligature[ -]+ties|o[ -]?rings?)\b/gi, 'Elastische Ligaturen')
    .replace(/\bwire[ -]+ligatures?\b/gi, 'Drahtligaturen')
    .replace(/\b(?:closed[ -]+coil[ -]+springs?|closing[ -]+springs?)\b/gi, 'Zugfeder')
    .replace(/\bopen[ -]+coil[ -]+springs?\b/gi, 'Druckfeder offen')
    .replace(/\bbuccal[ -]+tubes?\b/gi, 'Tubes')
    .replace(/\bbondable[ -]+buttons?\b/gi, 'Klebeknöpfchen')
    .replace(/\bbite[ -]+ramps?\b/gi, 'Bite Turbo')
    .replace(/\b(?:orthodontic|dental|braces)[ -]+wax\b/gi, 'Patientenschutzwachs')
    .replace(/\b(?:separators?|spacers?)\b/gi, 'Separiergummis')
    .replace(/\b(?:temporary[ -]+anchorage[ -]+devices?|mini[ -]?screws?|TADs?)\b/gi, 'Mini Schraube')
    .replace(/\blight[ -]+cur(?:e|ed|ing)\b/gi, 'lichthärtend')
    .replace(/\betch(?:ing)?[ -]+gels?\b/gi, 'Ätzgel')
    .replace(/(?<![\w.,])[.,]?(0\d{2})\s*["“”″]?\s*[x×]\s*[.,]?(0\d{2})["“”″]?(?!\d)/gi, '.$1 x .$2');
  if (/\b(?:Bögen|wires?|Draht|Drähte|Brackets?|Tubes?|Ligaturen)\b|\.0\d{2}|\b0\d{2}\b/i.test(query)) {
    query = query.replace(/\bSS\b/gi, 'Edelstahl').replace(/\bOK\b/gi, 'Oberkiefer').replace(/\bUK\b/gi, 'Unterkiefer');
  }
  return query.replace(/\s+/g, ' ').trim();
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  const field = form.matches('form[role="search"]') ? form.querySelector('input[name="q"]') : null;
  if (!field) return;
  field.value = dontixNormalizeSearch(field.value);
  form.querySelectorAll('[data-dontix-size-filter]').forEach((input) => input.remove());
  const size = field.value.match(/\.(0\d{2}) x \.(0\d{2})/);
  if (size && !form.querySelector('[name="filter.p.m.custom.available_sizes"]')) {
    const filter = document.createElement('input');
    filter.type = 'hidden';
    filter.name = 'filter.p.m.custom.available_sizes';
    filter.value = `.${size[1]}“ x .${size[2]}“`;
    filter.dataset.dontixSizeFilter = '';
    form.append(filter);
  }
}, true);

/**
 *  @class
 *  @function SearchForm
 */
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.is_drawer = this.dataset.drawer;
      this.drawer = this.closest('#Search-Drawer');
      this.form = this.querySelector('form');
      this.button = document.querySelectorAll('.thb-quick-search');
      this.input = this.querySelector('.search-field');
      this.defaultTab = this.querySelector('.side-panel-content--initial');
      this.predictiveSearchResults = this.is_drawer ? this.querySelector('.side-panel-content--has-tabs') : this.querySelector('.thb-predictive-search');
      this.cc = this.querySelector('.searchform--click-capture');
      this.promotionTemplate = this.querySelector('.thb-predictive-search--promotion-template');
      this.promotionHydrated = false;
      this.cache = new Map();
      this.cacheLimit = 50;
      this.lastSearchTerm = '';
      this.requestId = 0;
      this.status = this.querySelector('.dontix-search-status');

      this.onSearchKeyDownBound = this.onSearchKeyDown.bind(this);
      this.onSearchInputBound = () => this.resetKeyboardSelection();
      this.addEventListener('keydown', this.onSearchKeyDownBound);
      this.input.addEventListener('input', this.onSearchInputBound);
      this.setupEventListeners();
    }

    hydratePromotion() {
      if (!this.promotionTemplate) {
        return;
      }
      this.promotionTemplate.parentNode.insertBefore(
        this.promotionTemplate.content,
        this.promotionTemplate
      );
      this.promotionTemplate.remove();
      this.promotionTemplate = null;
      this.promotionHydrated = true;
    }

    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));

      // No results container means predictive search is disabled: the field
      // stays a plain search input that submits to the search page.
      if (this.predictiveSearchResults) {
        this.input.addEventListener('input', debounce((event) => {
          this.onChange(event);
        }, 300).bind(this));
        this.input.addEventListener('focus', debounce((event) => {
          this.onChange(event);
        }, 300).bind(this));
      }

      this.button.forEach((item) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          this.hydratePromotion();
          if (this.is_drawer) {
            OverlayManager.open(this.drawer);
            setTimeout(() => {
              this.input.focus({
                preventScroll: true
              });
            }, 100);
          } else {
            document.body.classList.add('open-cc');
          }
          return false;
        });
      });

      if (!this.is_drawer) {
        this.onCcClickBound = this.close.bind(this);
        this.onKeyUpBound = (e) => {
          if (e.code && e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        };
        this.cc?.addEventListener('click', this.onCcClickBound);
        document.addEventListener('keyup', this.onKeyUpBound);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('keydown', this.onSearchKeyDownBound);
      this.input.removeEventListener('input', this.onSearchInputBound);
      this.requestId++;
      this.requestController?.abort();
      if (this.onKeyUpBound) {
        document.removeEventListener('keyup', this.onKeyUpBound);
      }
      if (this.onCcClickBound && this.cc) {
        this.cc.removeEventListener('click', this.onCcClickBound);
      }
    }

    resetKeyboardSelection() {
      this.predictiveSearchResults?.querySelectorAll('.dontix-search-selected').forEach((item) => item.classList.remove('dontix-search-selected'));
    }

    onSearchKeyDown(event) {
      if (event.key === 'Escape') this.input.setAttribute('aria-expanded', 'false');
      if (event.isComposing || !this.predictiveSearchResults) return;
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      if (!this.predictiveSearchResults.classList.contains('active') || this.predictiveSearchResults.classList.contains('loading')) return;
      const items = Array.from(this.predictiveSearchResults.querySelectorAll('.tab-active .product-card-small--link, .tab-active .cart-product-link, .tab-active .predictive-search__item, #search-results-submit')).filter((item) => item.getClientRects().length);
      if (!items.length) return;
      if (event.target !== this.input && !items.includes(event.target)) return;
      event.preventDefault();
      const current = items.indexOf(event.target);
      let next = event.key === 'ArrowDown' ? current + 1 : current - 1;
      if (current === -1) next = event.key === 'ArrowDown' ? 0 : items.length - 1;
      if (next < 0 || next >= items.length) {
        this.resetKeyboardSelection();
        this.input.focus();
        return;
      }
      this.resetKeyboardSelection();
      items[next].classList.add('dontix-search-selected');
      items[next].focus();
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();
      this.resetKeyboardSelection();

      if (!searchTerm.length) {
        this.lastSearchTerm = '';
        this.requestId++;
        this.requestController?.abort();
        this.showDefaultContent();
        return;
      }
      if (!this.is_drawer) {
        this.open();
      }
      if (searchTerm === this.lastSearchTerm) {
        return;
      }
      this.lastSearchTerm = searchTerm;
      this.showSearchResults();
      this.getSearchResults(searchTerm);
    }

    showDefaultContent() {
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.classList.remove('active', 'loading');
        this.predictiveSearchResults.removeAttribute('aria-busy');
        this.input.setAttribute('aria-expanded', 'false');
        if (this.status) this.status.textContent = '';
        this.predictiveSearchResults.innerHTML = '';
      }
      if (this.defaultTab) {
        this.defaultTab.style.display = '';
      }
      if (!this.is_drawer) {
        this.close();
      }
    }

    showSearchResults() {
      if (this.defaultTab) {
        this.defaultTab.style.display = 'none';
      }
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.classList.add('active');
        this.input.setAttribute('aria-expanded', 'true');
      }
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    async getSearchResults(searchTerm) {
      const query = dontixNormalizeSearch(searchTerm);
      const requestId = ++this.requestId;
      this.requestController?.abort();
      const cached = this.cache.get(query);
      if (cached) {
        this.renderSearchResults(cached);
        return;
      }
      this.requestController = new AbortController();
      this.predictiveSearchResults.classList.add('loading');
      this.predictiveSearchResults.setAttribute('aria-busy', 'true');
      try {
        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'product,query,page',
          'resources[limit]': '8',
          'resources[limit_scope]': 'each',
          'resources[options][unavailable_products]': 'last',
          section_id: 'predictive-search'
        });
        const response = await fetch(`${theme.routes.predictive_search_url}?${params}`, { signal: this.requestController.signal });
        if (!response.ok) throw new Error(response.status);
        const text = await response.text();
        const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        if (!section) throw new Error('Missing predictive search section');
        if (this.cache.size >= this.cacheLimit) this.cache.delete(this.cache.keys().next().value);
        this.cache.set(query, section.innerHTML);
        if (requestId === this.requestId && this.getQuery() === searchTerm) this.renderSearchResults(section.innerHTML);
      } catch (error) {
        if (error.name === 'AbortError' || requestId !== this.requestId || this.getQuery() !== searchTerm) return;
        this.predictiveSearchResults.replaceChildren();
        const message = document.createElement('p');
        message.className = 'dontix-search-help';
        message.textContent = this.dataset.error;
        this.predictiveSearchResults.append(message);
        if (this.status) this.status.textContent = this.dataset.error;
        this.lastSearchTerm = '';
      } finally {
        if (requestId === this.requestId) {
          this.predictiveSearchResults.classList.remove('loading');
          this.predictiveSearchResults.removeAttribute('aria-busy');
        }
      }
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      const normalizedQuery = dontixNormalizeSearch(this.getQuery());
      const families = [
        [/\bSelbstligierend\b/i, /(?:pacifica-sl|vintera-sl)/],
        [/\bElastische Ketten\b/i, /elastische-ketten/],
        [/\bElastische Ligaturen\b/i, /elastische-ligaturen/],
        [/\bDrahtligaturen\b/i, /(?:drahtligaturen|kobayashi-ligaturen)/],
        [/\bZugfeder\b/i, /zugfeder/],
        [/\bDruckfeder offen\b/i, /druckfeder-offen/],
        [/\bPatientenschutzwachs\b/i, /patientenschutzwachs/],
        [/\bMini Schraube\b/i, /titan-tad-mini-schraube/],
        [/\bTMA\b/i, /tma/]
      ];
      this.predictiveSearchResults.querySelectorAll('product-card-small').forEach((card) => {
        const handle = card.dataset.productHandle || '';
        if (families.some(([term, family]) => term.test(normalizedQuery) && !family.test(handle))) {
          card.remove();
          return;
        }
        const title = (card.querySelector('.product-card-small--link')?.textContent || '') + ' ' + handle;
        if (/nickel titan/i.test(normalizedQuery) && !/nickel[ -]*titan|niti/i.test(title)) card.remove();
        if (/edelstahl/i.test(normalizedQuery) && !/edelstahl|stainless/i.test(title)) card.remove();
      });
      const size = normalizedQuery.match(/\.(0\d{2}) x \.(0\d{2})/);
      if (size) {
        const wanted = `.${size[1]}x.${size[2]}`;
        this.predictiveSearchResults.querySelectorAll('product-card-small').forEach((card) => {
          const values = (card.dataset.searchValues || '').replace(/["“”″\s]/g, '').toLowerCase().replace(/×/g, 'x');
          if (!values.includes(wanted)) card.remove();
        });
      }
      if (!this.predictiveSearchResults.querySelector('product-card-small')) {
        const recovery = this.predictiveSearchResults.querySelector('.dontix-search-recovery');
        const panel = this.predictiveSearchResults.querySelector('.side-panel-content--tab-panel');
        if (recovery && panel) panel.append(recovery.content.cloneNode(true));
      }
      this.predictiveSearchResults.classList.remove('loading');
      this.predictiveSearchResults.removeAttribute('aria-busy');
      if (this.status) {
        const count = this.predictiveSearchResults.querySelectorAll('product-card-small').length;
        this.status.textContent = this.dataset.count?.replace('[count]', count);
      }
      const submitBtn = this.predictiveSearchResults.querySelector('#search-results-submit');
      if (submitBtn) {
        if (!this.is_drawer) {
          submitBtn.classList.remove('button');
        }
        submitBtn.addEventListener('click', () => {
          this.form.requestSubmit();
        });
      }
    }

    close() {
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.setAttribute('inert', '');
      }
      this.input.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('open-search');
    }
    open() {
      document.body.classList.add('open-search');
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.removeAttribute('inert');
      }
    }
  }
  customElements.define('search-form', SearchForm);
}

